// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { createContext, useContext } from 'react';
import type { ApprovalPlan } from '../../../hooks/usePlanDetail';
import type { PlanFile } from '../../../types';

export interface PlanDetailContextValue {
  plan: ApprovalPlan;
  planFile: PlanFile;
  onStatusUpdated: (_status: 'APPROVED' | 'REJECTED', _comment?: string) => Promise<void>;
}

export const PlanDetailContext = createContext<PlanDetailContextValue | null>(null);

export function usePlanDetailContext(): PlanDetailContextValue {
  const ctx = useContext(PlanDetailContext);
  if (!ctx) {
    throw new Error('usePlanDetailContext must be used within a PlanDetailContext.Provider');
  }
  return ctx;
}
